import TypeaheadCSS from 'app/common/react/components/growth/unauth/header/UnauthHeader/TypeaheadCSS';

// SearchBox CSS

const cssStyles = () => {
  const styles = `
.OpenSearchInputToken__tokenSpan {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.OpenSearchInputToken__tokenSpan:hover {
  background: rgba(0, 0, 0, 0.06);
}
.OpenSearchInputToken__tokenSpan.remove svg {
  display: block;
}
.OpenSearchBoxInput {
  -webkit-font-smoothing: antialiased;
  color: #333;
}
.SearchBoxEducation {
  -webkit-transition: visibility 0.5s, opacity 0.5s;
  opacity: 0;
  transition: visibility 0.5s, opacity 0.5s;
  visibility: hidden;
}
.SearchBoxEducation.animate {
  opacity: 1;
  visibility: visible;
}
`;

  return styles + TypeaheadCSS();
};

export default cssStyles;
